export const FETCH_INVENTORY_TYPE = "FETCH_INVENTORY_TYPE"